import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';
import { VideoRenderer } from 'core';
import { videoFadeInAnimation } from 'ui/mixins';
import { BasePlaceholder, VideoLoadingOverlay } from '../view';

export { VideoLoadingOverlay };

export const PlaceholderWrapper = styled.div`
    background: ${(props) => props.theme.root.colors.basicColors['8%']};
    display: flex;
    width: 100%;
    height: 100%;
    container-type: size;
`;

export const Placeholder = styled(BasePlaceholder)`
    container-type: size;
    font-size: 32px;
    height: 150px;
    width: 150px;

    @container (max-width: 480px) {
        font-size: 24px;
        height: 80px;
        width: 80px;
    }

    @container (max-width: 320px) {
        font-size: 20px;
        height: 56px;
        width: 56px;
    }

    @container (max-width: 180px) {
        font-size: 14px;
        height: 40px;
        width: 40px;
    }
`;

export const GridVideoRenderer = styled(VideoRenderer)<{ $objectFit: string; $isReady?: boolean }>`
    height: 100%;
    width: 100%;
    ${({ $objectFit }) => ($objectFit ? `object-fit: ${$objectFit};` : null)}
    ${videoFadeInAnimation}
`;

export const SIPPlaceholder = styled(BasePlaceholder)<{
    participantId: string;
}>`
    container-type: size;
    height: 150px;
    width: 150px;

    @container (max-width: 480px) {
        height: 80px;
        width: 80px;
    }

    @container (max-width: 320px) {
        height: 56px;
        width: 56px;
    }

    @container (max-width: 180px) {
        height: 40px;
        width: 40px;
    }
`;

export const SIPCallIcon = styled(Icon)`
    --icon-color: ${(props) => props.theme.root.colors.basicColors.black['50%']};

    height: 48px !important;
    width: 48px !important;

    @container (max-width: 80px) {
        height: 32px !important;
        width: 32px !important;
    }

    @container (max-width: 56px) {
        height: 24px !important;
        width: 24px !important;
    }
`;
